import { MenuItem } from 'primereact/menuitem';
import { AuthState } from '../context';
import { PermissionSet } from '../helper';
import { RoleType } from './roleTypes';

export const SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type BmweMenuItem = MenuItem & {
  routePath?: string;
  permission?: PermissionSet;
};

export interface RouterContext {
  auth: AuthState;
}

export interface UserModel {
  id: string;
  name: string;
  email?: string | null;
}

export interface ActiveUser extends UserModel {
  signatureInitials?: string | null;
  roleAssignments: RoleAssignmentModel[];
  groups: GroupModel[];
}

export interface GroupModel {
  id?: string;
  name: string;
  roleAssignments: RoleAssignmentModel[];
}

export interface RoleAssignmentModel {
  id?: string | null;
  userId?: string | null;
  objectType?: string | null;
  roleType: RoleType;
  dossierId?: string | null;
}
